import { DemandTopicStatus, FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';
import { ReactNode } from 'react';
import { getDemandTopicStatusTranslationId } from '@synergy/utils';

export const DemandTopicStatusFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (status?: DemandTopicStatus) => {
        filter.delete(FilterParams.Status);
        if (status) {
            filter.set(FilterParams.Status, status);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (status: unknown): ReactNode => {
        if (typeof status !== 'string') {
            return '';
        }

        return <FormattedMessage id={getDemandTopicStatusTranslationId(status as DemandTopicStatus)} />;
    };

    registerFilterMap(FilterParams.Status, getDisplayValue);

    const options = Object.values(DemandTopicStatus).map<SelectOption>(status => {
        return {
            value: status,
            displayValue: <FormattedMessage id={getDemandTopicStatusTranslationId(status)} />,
        };
    });

    return (
        <PoolSelect
            displayEmpty={true}
            name={FilterParams.Status}
            label={<FormattedMessage id="app.label.status" />}
            value={filter.get(FilterParams.Status)}
            onValueChange={onSelected}
            noSorting={true}
            options={options}
        />
    );
};
